<template>
  <div class="rounded bg-stone-50 p-3 text-lg flex flex-col justify-between border-stone-100 border-3" v-if="peak">
    <div pb-3>
      <div text-stone-600 lh-snug font-semibold text-xl>
        {{ peak.properties["name_int"] }}
      </div>
      <div text-stone-500 font-mono text-sm>
        {{ distanceFormatted }} mi
        {{ headingDirectionFormatted(peak.properties.bearing) }}
      </div>
    </div>
    <div>
      <div font-mono text-stone-400 lh-snug>Elevation</div>
      <div text-3xl font-semibold text-stone-700 tabular-nums>{{ numberFormatted(peak.properties.ele_ft) }} ft</div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  peak: {
    type: Object,
  },
});
const distanceFormatted = computed(() => {
  if (!props.peak) {
    return null;
  }
  const distanceMiles = props.peak.properties.distance * 0.621371;
  return numberFormatted(distanceMiles);
});
</script>
